import {
    ADD_USAGES,
    ADD_ENV,
    ADD_INFO,
    ADD_USAGE_LIMIT,
    ADD_AGENTIC_SUITE
} from '../Constants/createInstance.constants';

const initalState = {
    usageDetails: {},
    environemtDetails: {},
    info: {},
    usageLimit: {},
    agenticSuite: [
        { aiAgentKey: 'aiSupportAgent', enabled: false, expiry: null, licensesCount: null, crms: [] },
        { aiAgentKey: 'aiCaseQAAgent', enabled: false, expiry: null, licensesCount: null, crms: [] },
        { aiAgentKey: 'aiAgentPartner', enabled: false, expiry: null, licensesCount: null, crms: [] },
        { aiAgentKey: 'aiKnowledgeAgent', enabled: false, expiry: null, licensesCount: null, crms: [] },
    ]
};

export default (state = initalState, action) => {
    switch (action.type) {
        case ADD_USAGES:
            return {
                ...state,
                usageDetails: action.data
            };
        case ADD_ENV:
            return {
                ...state,
                environemtDetails: action.data
            };
        case ADD_INFO:
            return {
                ...state,
                info: action.data
            };
        case ADD_USAGE_LIMIT:
            return {
                ...state,
                usageLimit: action.data
            };
        case ADD_AGENTIC_SUITE:
            return {
                ...state,
                agenticSuite: action.data
            };
        default:
            return state;
    }
};
